<template>
  <div class="info-item mb-3">
    <div class="d-flex align-center">
      <div class="text-caption text-grey" style="width: 120px;">{{ label }}:</div>
      
      <div class="d-flex align-center flex-grow-1">
        <div v-if="endereco && isEndereco" class="mr-2">
          <v-avatar size="24" color="primary" class="text-white caption">
            <span>{{ formatEndereco(valor) }}</span>
          </v-avatar>
        </div>
        
        <span 
          :class="{'text-truncate': truncar, 'font-weight-medium': destacar}"
          :style="truncar ? {maxWidth: '300px'} : {}"
        >
          {{ valorExibido }}
        </span>
        
        <v-btn
          v-if="copiavel"
          icon
          variant="text"
          size="small"
          @click="copiarValor"
          class="ml-2"
        >
          <v-icon size="small">{{ copiado ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
        </v-btn>
        
        <v-btn
          v-if="linkExterno"
          icon
          variant="text"
          size="small"
          :href="linkExterno"
          target="_blank"
          class="ml-1"
        >
          <v-icon size="small">mdi-open-in-new</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoItem',
  props: {
    label: {
      type: String,
      required: true
    },
    valor: {
      type: [String, Number, Boolean],
      required: true
    },
    copiavel: {
      type: Boolean,
      default: false
    },
    linkExterno: {
      type: String,
      default: null
    },
    truncar: {
      type: Boolean,
      default: true
    },
    destacar: {
      type: Boolean,
      default: false
    },
    endereco: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      copiado: false
    }
  },
  computed: {
    valorExibido() {
      return this.valor
    },
    isEndereco() {
      // Verifica se o valor parece um endereço Ethereum (0x...)
      return typeof this.valor === 'string' && 
             this.valor.startsWith('0x') && 
             this.valor.length >= 40
    }
  },
  methods: {
    copiarValor() {
      navigator.clipboard.writeText(this.valor.toString())
        .then(() => {
          this.copiado = true
          setTimeout(() => {
            this.copiado = false
          }, 2000)
        })
        .catch(err => {
          console.error('Erro ao copiar:', err)
        })
    },
    
    formatEndereco(endereco) {
      if (!endereco || typeof endereco !== 'string') return ''
      
      // Pega as primeiras duas letras do endereço após o 0x
      return endereco.substring(2, 4).toUpperCase()
    }
  }
}
</script>

<style scoped>
.info-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}
</style>
